import { useEffect, useState } from 'react';
import Banner from '../common/Banner';
import './ContentWrapper.scss';

const ContentWrapper = ({ children, campaign }) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 768px)');
        const handleMediaQueryChange = (event) => {
            setIsMobile(event.matches);
        };

        // Set initial value
        setIsMobile(mediaQuery.matches);

        // Add listener
        mediaQuery.addEventListener('change', handleMediaQueryChange);

        // Clean up listener on unmount
        return () => {
            mediaQuery.removeEventListener('change', handleMediaQueryChange);
        };
    }, []);

    return (
        <>
            {isMobile && (
                <Banner campaign={campaign} />
            )}
            <div className="element-container">
                <main id="content-wrapper">
                    <div className="content">
                        {children}
                    </div>
                    {!isMobile && (
                        <div className="banner">
                            <Banner campaign={campaign} />
                        </div>
                    )}
                </main>
            </div>
        </>
    );
};

export default ContentWrapper;
